import { z } from "zod"

export const PriceObjectDtoSchema = z
  .object({
    value: z.number(),
    currency: z.string(),
  })
  .meta({ id: "PriceObjectDtoSchema" })

export type PriceObjectDto = z.infer<typeof PriceObjectDtoSchema>
